<template>
  <!-- 中奖列表 -->
  <div class="m-coupon-list">
    <div class="list">
      <div v-for="(item, index) in list" :key="index">
        <div class="item" v-if="item.prizeStatus != 2 || type != 'end'">
          <div class="img">
            <van-image class="s" :src="item.avatar" fit="cover" />
          </div>
          <div class="name text-line">{{ item.nickname }}</div>
          <div v-if="item.prizeStatus == 0" class="status status01">
            <div class="s s1"></div>
            <span class="t">未中奖</span>
          </div>
          <div
            v-if="item.prizeStatus == 1 && item.confirmState == 0"
            class="status status02"
          >
            <div class="s s4"></div>
            <span class="t">已中奖,待确认</span>
          </div>
          <div
            v-if="item.prizeStatus == 1 && item.confirmState == 1"
            class="status status02"
          >
            <div class="s s2"></div>
            <span class="t">已中奖,确认完成</span>
          </div>
          <div v-if="item.prizeStatus == 2" class="status status01">
            <div class="s s1"></div>
            <span class="t">已放弃</span>
          </div>
          <div v-if="item.prizeStatus == 3" class="status status03">
            <div class="s s3"></div>
            <span class="t">候补成功</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { Image as VanImage } from "vant";

export default {
  name: "MCouponList",

  data() {
    return {};
  },
  components: { VanImage },

  props: {
    list: {
      type: Array,
      default: () => [],
    },

    type: {
      type: String,
      default: () => "",
    },
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  mounted() {},

  methods: {},
};
</script>

<style lang="less">
.m-coupon-list {
  overflow-y: auto;
  max-height: 150px;
  margin-bottom: 20px;
  .list {
    width: 100%;
    .item {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 26px;
      margin-bottom: 10px;
      .img {
        width: 25px;
        height: 25px;
        padding-right: 15px;
        .s {
          overflow: hidden;
          width: 25px;
          height: 25px;
          margin: 0 auto;
          border-radius: 50%;
        }
      }
      .name {
        width: 114px;
        text-align: left;
        font-weight: 400;
        font-size: 13px;
        color: rgba(0, 0, 0, 0.54);
      }
      .status {
        display: flex;
        align-items: center;
        justify-content: right;
        width: 130px;
        text-align: right;
        font-weight: 400;
        font-size: 11px;
        color: #7ea7ff;
        box-sizing: border-box;
        .s {
          width: 13px;
          height: 13px;
          margin-right: 5px;
          background-repeat: no-repeat;
          background-size: 100% 100%;
          background-position: left bottom;
        }
        .s1 {
          background-image: url("../assets/image/icon-coupon-s01.png");
        }
        .s2 {
          background-image: url("../assets/image/icon-coupon-s02.png");
        }
        .s3 {
          background-image: url("../assets/image/icon-coupon-s03.png");
        }
        .s4 {
          background-image: url("../assets/image/icon-coupon-s04.png");
        }
      }
      .status01 {
        .t {
          color: #ff8fea;
        }
      }
      .status03 {
        .t {
          color: rgba(0, 0, 0, 0.3);
        }
      }
    }
  }
}
</style>
